import { useBrowserWalletConnect } from '@socios-blk/browser';
import { type WalletConnectSession } from '@socios-blk/core';
import React, { memo, type PropsWithChildren, useEffect, useState } from 'react';

import { useWalletConnectConfirmationModal, useWalletConnectEventHandler } from '../hooks';

import { WalletConnectContext } from './walletConnectContext';

export const WalletConnectProviderOn = memo(function WalletConnectProviderOn({ children }: PropsWithChildren) {
	const [walletConnectSessions, setWalletConnectSession] = useState<Array<WalletConnectSession>>([]);
	const { eventHandler } = useWalletConnectEventHandler();
	const { confirmAction } = useWalletConnectConfirmationModal(walletConnectSessions);

	const { activeSessions, connectWallet, disconnectWallet } = useBrowserWalletConnect({
		confirmAction,
		enabled: true,
		eventHandler
	});

	useEffect(() => {
		const sessions = Object.entries(activeSessions || {}).map(([_, session]) => session);

		setWalletConnectSession(sessions);
	}, [activeSessions]);

	return (
		<WalletConnectContext.Provider
			value={{
				connectWallet,
				disconnectWallet,
				walletConnectEventHandler: eventHandler,
				walletConnectSessions
			}}
		>
			{children}
		</WalletConnectContext.Provider>
	);
});
